<template>
  <section class="dp-layout">
    <section class="dp-right op-page op-page--scroll">
    <header class="op-page__head">
      <div>
        <div class="op-page__eyebrow">Operations overview</div>
        <h3 class="op-page__title">开放平台概览</h3>
        <p class="op-page__desc">集中查看开放请求质量、天波同步积压和合作方回调健康度，优先处理影响业务连续性的异常。</p>
      </div>
      <el-button size="small" icon="el-icon-refresh" :loading="loading" @click="load">刷新概览</el-button>
    </header>

    <div v-loading="loading" class="op-dash">
      <div class="op-section">
        <div class="op-section__title">请求质量</div>
        <div class="op-dash__row">
          <div class="op-card" v-for="item in callCards" :key="item.label">
            <div class="op-card__label">{{ item.label }}</div>
            <div class="op-card__value">{{ item.value }}</div>
            <div v-if="item.tip" class="op-card__tip">{{ item.tip }}</div>
          </div>
        </div>
      </div>

      <div class="op-section">
        <div class="op-section__title">天波出站队列</div>
        <div class="op-dash__row">
          <div class="op-card" v-for="item in queueCards" :key="item.label">
            <div class="op-card__label">{{ item.label }}</div>
            <div class="op-card__value" :class="item.warn ? 'is-warn' : ''">{{ item.value }}</div>
            <div v-if="item.tip" class="op-card__tip">{{ item.tip }}</div>
          </div>
        </div>
      </div>

      <div class="op-section">
        <div class="op-section__title">合作方回调队列</div>
        <div class="op-dash__row">
          <div class="op-card" v-for="item in callbackCards" :key="item.label">
            <div class="op-card__label">{{ item.label }}</div>
            <div class="op-card__value" :class="item.warn ? 'is-warn' : ''">{{ item.value }}</div>
            <div v-if="item.tip" class="op-card__tip">{{ item.tip }}</div>
          </div>
        </div>
      </div>

      <div class="op-panel">
        <div class="op-panel__title">学校积压排行（前 20 所）</div>
        <el-table :data="stats.SchoolQueues || []" size="small" empty-text="当前没有学校积压任务">
          <el-table-column prop="SchoolName" label="学校" min-width="160" show-overflow-tooltip />
          <el-table-column prop="SchoolId" label="学校编号" min-width="160" show-overflow-tooltip />
          <el-table-column prop="BacklogCount" label="未完成数" width="100" align="right" />
        </el-table>
      </div>
    </div>
    </section>
  </section>
</template>

<script>
import { getOpenPlatformDashboard } from '@/api/modules/openPlatform';

export default {
  name: 'OpenPlatformDashboard',
  data() {
    return {
      loading: false,
      stats: {}
    };
  },
  computed: {
    callCards() {
      const s = this.stats || {};
      return [
        { label: '今天请求次数', value: s.TodayCallCount || 0 },
        { label: '近7天请求次数', value: s.Last7DaysCallCount || 0 },
        { label: '今天成功比例', value: (s.TodaySuccessRate || 0) + '%' },
        { label: '近7天成功比例', value: (s.Last7DaysSuccessRate || 0) + '%' },
        {
          label: '今天慢请求大概多久',
          value: (s.TodayP95Ms || 0) + '毫秒',
          tip: '写接口要等同步，几秒属正常'
        },
        {
          label: '近7天慢请求大概多久',
          value: (s.Last7DaysP95Ms || 0) + '毫秒',
          tip: '写接口要等同步，几秒属正常'
        },
        { label: '今天被挡次数', value: s.Today429Count || 0, tip: '请求太猛被系统拦住' },
        { label: '近7天被挡次数', value: s.Last7Days429Count || 0, tip: '请求太猛被系统拦住' }
      ];
    },
    queueCards() {
      const s = this.stats || {};
      return [
        { label: '还没处理完', value: s.PendingCount || 0 },
        { label: '失败等再试', value: s.RetryPendingCount || 0, warn: !!s.RetryPendingCount },
        { label: '结果不清楚', value: s.UnknownOutcomeCount || 0, warn: !!s.UnknownOutcomeCount },
        { label: '需要人工看着', value: s.ManualReviewCount || 0, warn: !!s.ManualReviewCount },
        { label: '近7天同步成功比例', value: (s.TbSyncSuccessRate7d || 0) + '%' }
      ];
    },
    callbackCards() {
      const s = this.stats || {};
      return [
        { label: '还没推出去', value: s.CallbackPendingCount || 0 },
        { label: '推失败再试中', value: s.CallbackRetryCount || 0, warn: !!s.CallbackRetryCount },
        {
          label: '多次失败已放弃',
          value: s.CallbackDeadCount || 0,
          warn: !!s.CallbackDeadCount,
          tip: '需要到回调日志里人工处理'
        }
      ];
    }
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      getOpenPlatformDashboard().then(res => {
        this.loading = false;
        if (res.data && res.data.success) {
          this.stats = res.data.response || {};
        } else {
          this.$message.error((res.data && res.data.msg) || '加载失败');
        }
      }).catch(() => {
        this.loading = false;
      });
    }
  }
};
</script>
